import React from 'react';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
    shopLayout: {
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    
    content: {
        flex: 1,
    },
});

export const StoreLayoutV1New: React.FC = () => {
    const styles = useStyles();

    return (
        <div className={styles.shopLayout}>
            {/* New header will go here */}
            <header style={{ padding: '20px', backgroundColor: '#222', color: '#fff' }}>
                <h2>New Store Header</h2>
            </header>
            
            <div className={styles.content}>
                <Outlet />
            </div>
            
            {/* New footer will go here */}
            <footer style={{ padding: '20px', backgroundColor: '#222', color: '#fff' }}>
                <p>New Store Footer</p>
            </footer>
        </div>
    );
};
